import * as React from 'react';
import { clsx } from 'clsx';
import { SingleSelectItem } from '../../../internal';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export function GroupedSelectMobileOptions(props) {
  var indented = props.indented,
    options = props.options,
    value = props.value,
    onChange = props.onChange;
  return /*#__PURE__*/_jsx("div", {
    className: styles['list'],
    children: options.map(function (option) {
      var optionValue = option.value;
      var key = String(optionValue);
      var selected = value === optionValue;
      return /*#__PURE__*/_jsx("div", {
        className: clsx(styles['item-wrapper'], indented && styles['indented']),
        children: /*#__PURE__*/_jsx("div", {
          className: styles['item'],
          children: /*#__PURE__*/_jsx(SingleSelectItem, {
            option: option,
            selected: selected,
            onClick: function onClick() {
              onChange(optionValue);
            },
            role: "option",
            "aria-selected": selected ? 'true' : undefined
          })
        })
      }, key);
    })
  });
}